module.exports = __webpack_public_path__ + "img/demo3-weight-ja.e3efeb0d.png";